import * as React from 'react';
import classNames from 'classnames';
import Box from "../Box";
export var DialogFooter = function DialogFooter(_ref) {
  var className = _ref.className,
      _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? 'row' : _ref$direction,
      end = _ref.end,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? 'default' : _ref$mode,
      start = _ref.start,
      alignItems = _ref.alignItems,
      left = _ref.left,
      right = _ref.right;
  var classes = classNames('Dialog-footer', className);
  return /*#__PURE__*/React.createElement(Box, {
    className: classes,
    divider: mode === 'compact' ? null : {
      color: 'light',
      side: 'top',
      width: 1
    },
    flex: {
      direction: direction,
      justifyContent: 'flex-end'
    },
    flexBasis: "auto",
    flexGrow: 1,
    flexShrink: 0,
    padding: {
      bottom: 16,
      horizontal: 20,
      top: mode === 'compact' ? 4 : 16
    }
  }, start && /*#__PURE__*/React.createElement(Box, {
    flex: true,
    flexBasis: "auto",
    flexGrow: 1,
    flexShrink: 1
  }, start), end && /*#__PURE__*/React.createElement(Box, {
    flex: true,
    flexBasis: "auto",
    flexGrow: 0,
    flexShrink: 0
  }, end));
};